'use client';
import {useActionState} from 'react';
import {Loader2, Zap} from 'lucide-react';
import {login, type AuthState} from '@/app/actions/auth';
import {Button} from '@/components/ui/button';
import {Input} from '@/components/ui/input';
import {Field, Notice} from '@/components/shared';

export default function AuthForm() {
  const [state, submit, pending] = useActionState(login, {} as AuthState);
  return <main className="flex min-h-dvh items-center justify-center px-4 py-10">
    <form action={submit} className="surface flex w-full max-w-sm flex-col gap-5 p-7">
      <div className="flex items-center gap-3"><span className="flex size-10 items-center justify-center rounded-xl text-white gradient-bg glow"><Zap className="size-5" strokeWidth={2.4} /></span><div><h1 className="text-lg font-semibold tracking-tight">AppDev</h1><p className="text-xs text-muted-foreground">Нэвтрэх</p></div></div>
      {state.error && <Notice>{state.error}</Notice>}
      <Field label="Хэрэглэгчийн нэр"><Input name="username" autoComplete="username" autoCapitalize="none" required className="h-10 rounded-xl" /></Field>
      <Field label="Нууц үг"><Input name="password" type="password" autoComplete="current-password" required className="h-10 rounded-xl" /></Field>
      <Button type="submit" disabled={pending} className="h-10 rounded-xl gradient-bg text-white hover:opacity-90">{pending && <Loader2 className="spin" />}Нэвтрэх</Button>
      <p className="text-center text-xs text-muted-foreground">Бүртгэлийг admin үүсгэнэ.</p>
    </form>
  </main>;
}
